export const pie_chart = () => (
  <path
    d="M21.21 15.89A10 10 0 118 2.83M22 12A10 10 0 0012 2v10h10z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
